import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Support from "@/pages/Support";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import FounderDashboard from "@/pages/admin/FounderDashboard";
import SmartRedirect from "@/pages/SmartRedirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/support" element={<Support />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/post/:id" element={<SmartRedirect kind="post" />} />
          <Route path="/video/:id" element={<SmartRedirect kind="video" />} />
          <Route path="/reel/:id" element={<SmartRedirect kind="reel" />} />
          <Route path="/profile/:username" element={<SmartRedirect kind="profile" />} />
          <Route path="/download" element={<SmartRedirect kind="download" />} />
          <Route path="/bossadmin" element={<Navigate to="/bossadmin/founder-creators" replace />} />
          <Route path="/bossadmin/login" element={<AdminLogin />} />
          <Route path="/bossadmin/founder-creators" element={<FounderDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "rgba(24,24,27,0.92)",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </div>
  );
}

export default App;
